import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Bands from "./pages/bands";
import { BusinessOpportunity } from "./pages/business-opportunity";
import CheckOut from "./pages/checkout";
import Payment from "./pages/payment";
import Shipping from "./pages/shipping";
import Confirmation from "./pages/confirmation";
import OrderSuccess from "./pages/confirmation/OrderSuccess";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: "",
        element: <Navigate to="/bands" />,
      },
      {
        path: "bands",
        element: <Bands />,
      },
      {
        path: "business-opportunity",
        element: <BusinessOpportunity />,
      },
      {
        path: "check-out",
        element: <CheckOut />,
      },
      {
        path: "payment",
        element: <Payment />,
      },
      {
        path: "shipping",
        element: <Shipping />,
      },
      {
        path: "confirmation",
        element: <Confirmation />,
      },
      {
        path: "order-success",
        element: <OrderSuccess />,
      },
    ],
  },
]);
